import React from 'react';

import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { ColorBoxFilter } from '../components/color-box-filter/ColorBoxFilter';
import { CustomFilterPopover } from '../components/CustomFilterPopover';
import { useFilterCount } from '../hooks';

export const ShoesColorsCheckboxesPopover = ({ onCountChange, ...props }) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const color = useWatch({ name: 'shoes_apparent_colors' });
  const filterCount = Array.isArray(color) && color.length > 0 ? 1 : 0;
  useFilterCount('shoes', filterCount, onCountChange);

  return (
    <CustomFilterPopover
      hasFilterValue={Boolean(filterCount)}
      testId="shoesFilter"
      triggerValue={t('events:shoes_colors')}
      {...props}
    >
      <ColorBoxFilter
        control={control}
        isMulti
        label={t('events:shoes_colors')}
        name="shoes_apparent_colors"
        options={EVENT_ENUMS.LOWER_BODY.SHOES.APPARENT_COLOR.raw}
      />
    </CustomFilterPopover>
  );
};
